import uniqid from 'uniqid'
import config from './config'

const topMenuItems = [
  {
    path: '/',
    text: 'menus.topmenu.new.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/alta/nueva-factura',
        text: 'menus.topmenu.new.create',
        active: true,
        key: uniqid()
      },
      {
        path: '/alta/importar',
        text: 'menus.topmenu.new.import',
        active: true,
        key: uniqid()
      }
    ]
  },
  /* {
    path: '/emitidas/financiacion',
    text: 'menus.topmenu.financing',
    active: config.features.requestFactoringMenuItem,
    key: uniqid()
  }, */
  {
    path: '/agenda',
    text: 'menus.topmenu.agenda',
    active: true,
    key: uniqid()
  },
  {
    path: '/',
    text: 'menus.topmenu.configuration.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/configuracion/datos-generales',
        text: 'menus.topmenu.configuration.companyData',
        active: true,
        key: uniqid()
      },
      {
        path: '/configuracion/users',
        text: 'menus.topmenu.configuration.users',
        active: true,
        key: uniqid()
      },
      {
        path: '/configuracion/not-factura',
        text: 'menus.topmenu.configuration.notification',
        active: true,
        key: uniqid()
      },
      {
        path: '/configuracion/gestion-de-claves',
        text: 'menus.topmenu.configuration.keys',
        active: config.features.hasKeyConfiguration,
        userRoleAllowed: ['ROLE_ADMIN'],
        userSubscriptionAllowed: ['PREMIUM'],
        key: uniqid()
      },
      {
        path: '/configuracion/catalogo',
        text: 'menus.topmenu.configuration.catalog',
        active: config.features.hasCatalog,
        key: uniqid()
      },
      {
        path: '/configuracion/formato-factura',
        text: 'menus.topmenu.configuration.invoiceFormat',
        active: true,
        key: uniqid()
      }
    ]
  },
  {
    path: '/',
    text: 'menus.topmenu.verifactu.title',
    active: config.features.hasVerifactuRequerimiento || config.features.hasVerifactuEnviadas || config.features.hasVerifactuComprobarHuella || config.features.hasVerifactuExportacion,
    verifactuParent: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/verifactu/requerimiento',
        text: 'menus.topmenu.verifactu.requerimiento',
        active: config.features.hasVerifactuRequerimiento,
        requiresVerifactuModalityN: true,
        key: uniqid()
      },
      {
        path: '/verifactu/enviadas',
        text: 'menus.topmenu.verifactu.enviadas',
        active: config.features.hasVerifactuEnviadas,
        requiresVerifactuModalitySN: true,
        key: uniqid()
      },
      {
        path: '/verifactu/comprobar-huella',
        text: 'menus.topmenu.verifactu.comprobarHuella',
        active: config.features.hasVerifactuComprobarHuella,
        requiresVerifactuModalityN: true,
        key: uniqid()
      },
      {
        path: '/verifactu/exportar-registros',
        text: 'menus.topmenu.verifactu.exportarRegistros',
        active: config.features.hasVerifactuExportacion,
        requiresVerifactuModalityN: true,
        key: uniqid()
      }
    ]
  },
  {
    path: '/',
    text: 'menus.topmenu.help.title',
    active: true,
    key: uniqid(),
    subMenu: [
      {
        path: '/ayuda/manual-usuario',
        text: 'menus.topmenu.help.manual',
        active: true,
        key: uniqid()
      },
      {
        path: '/ayuda/video',
        text: 'menus.topmenu.help.video',
        active: true,
        key: uniqid()
      },
      {
        path: '/ayuda/support',
        text: 'menus.topmenu.help.support',
        active: config.features.hasTechnicalSupport,
        key: uniqid()
      },
      {
        path: '/ayuda/acercade',
        text: 'menus.topmenu.help.about',
        active: true,
        key: uniqid()
      },
      {
        path: '/ayuda/sef-ticketbai-data',
        text: 'menus.topmenu.help.sefTicketbaiData',
        active: true,
        key: uniqid()
      },
      {
        path: '/ayuda/verifactu-statement',
        text: 'menus.topmenu.help.verifactuStatement',
        active: config.features.showVerifactu,
        key: uniqid()
      },
      {
        path: '/ayuda/verifactu',
        text: 'menus.topmenu.help.verifactu',
        active: config.features.showVerifactu,
        key: uniqid()
      }
    ]
  },
  {
    path: '/multiempresa',
    text: 'menus.topmenu.multiCompany.title',
    active: config.features.hasMultiCompany,
    key: uniqid()
  }
]

export default topMenuItems
